var _require = require('./simplify_text_attributes'),
    labels = _require.labels,
    descriptions = _require.descriptions,
    aliases = _require.aliases,
    lemmas = _require.lemmas,
    glosses = _require.glosses;

var _require2 = require('./simplify_claims'),
    claim = _require2.simplifyClaim,
    propertyClaims = _require2.simplifyPropertyClaims,
    claims = _require2.simplifyClaims,
    qualifier = _require2.simplifyQualifier,
    propertyQualifiers = _require2.simplifyPropertyQualifiers,
    qualifiers = _require2.simplifyQualifiers,
    references = _require2.simplifyReferences;

var _require3 = require('./simplify_forms'),
    form = _require3.simplifyForm,
    forms = _require3.simplifyForms;

var _require4 = require('./simplify_senses'),
    sense = _require4.simplifySense,
    senses = _require4.simplifySenses;

var sitelinks = require('./simplify_sitelinks');

var sparqlResults = require('./simplify_sparql_results');

module.exports = {
  labels: labels,
  descriptions: descriptions,
  aliases: aliases,
  claim: claim,
  propertyClaims: propertyClaims,
  claims: claims,
  qualifier: qualifier,
  propertyQualifiers: propertyQualifiers,
  qualifiers: qualifiers,
  references: references,
  sitelinks: sitelinks,
  // Aliases
  snak: claim,
  propertySnaks: propertyClaims,
  snaks: claims,
  // Lexemes
  lemmas: lemmas,
  glosses: glosses,
  form: form,
  forms: forms,
  sense: sense,
  senses: senses,
  sparqlResults: sparqlResults // Set in ./simplify_entity
  // entity,
  // entities,

};